import React, { Component } from 'react';
import PropTypes from 'prop-types';
import entityComposition from '../common/classes/entityComposition';
import Loader from '../common/loader';
import { makeOrganizationTree } from './assetSelectors';
import TieredSelect from '../common/lookups/tieredSelect';
import searchFactory from '../common/lookups/searchFactory';
const OrgSearch = searchFactory('orgFilterAsset');
class AssetOrganizationFilter extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    const _this$props = this.props,
      indexQuery = _this$props.orgFilterAsset.indexQuery,
      serverIndex = _this$props.orgFilterAssetActions.serverIndex;
    serverIndex(indexQuery);
  }
  handleChange(selectedValues, newValue) {
    const _this$props2 = this.props,
      filters = _this$props2.filters,
      onFilter = _this$props2.onFilter;
    const filterName = newValue.entity;
    if (filterName === 'organization' || filterName === 'facility' || filterName === 'facilityGroup' || filterName === 'facilityGroupArea') {
      let currentFilters = filters[filterName] ? filters[filterName] : [];
      if (currentFilters.some(at => at.id === newValue.id)) {
        // remove this from the list
        currentFilters = currentFilters.filter(at => at.id !== newValue.id);
      } else {
        const newFilter = {
          id: newValue.id,
          name: newValue.name
        };
        currentFilters = currentFilters.concat([newFilter]);
      }
      onFilter(filterName, currentFilters);
    }
  }
  render() {
    const _this$props3 = this.props,
      filters = _this$props3.filters,
      isLoading = _this$props3.isLoading,
      orgOptions = _this$props3.orgOptions,
      onBack = _this$props3.onBack;
    let selections = [];
    if (filters) {
      if (filters.organization) {
        selections = filters.organization;
      }
      if (filters.facility) {
        selections = selections.concat(filters.facility);
      }
      if (filters.facilityGroup) {
        selections = selections.concat(filters.facilityGroup);
      }
      if (filters.facilityGroupArea) {
        selections = selections.concat(filters.facilityGroupArea);
      }
    }
    return /*#__PURE__*/React.createElement(TieredSelect, {
      style: {
        minHeight: 100
      },
      label: "Organizations",
      data: orgOptions,
      value: selections,
      onBack: onBack,
      onChange: this.handleChange,
      backLabel: "Back"
    }, /*#__PURE__*/React.createElement(OrgSearch, null), /*#__PURE__*/React.createElement(Loader, {
      loaded: !isLoading
    }));
  }
}
AssetOrganizationFilter.defaultProps = {
  filters: {}
};
AssetOrganizationFilter.propTypes = {
  filters: PropTypes.shape({
    organization: PropTypes.arrayOf(PropTypes.shape({})),
    facility: PropTypes.arrayOf(PropTypes.shape({})),
    facilityGroup: PropTypes.arrayOf(PropTypes.shape({})),
    facilityGroupArea: PropTypes.arrayOf(PropTypes.shape({}))
  }),
  isLoading: PropTypes.bool.isRequired,
  orgFilterAsset: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  orgFilterAssetActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  orgOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onFilter: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired
};
export { AssetOrganizationFilter as TestAssetOrganizationFilter };
export default entityComposition(AssetOrganizationFilter, ['orgFilterAsset'], {
  orgOptions: state => makeOrganizationTree(state.orgFilterAsset.list),
  isLoading: state => state.orgFilterAsset.loading
}, []);